// calling both current and archived teacher
export const START_FETCH_POSTER_DETAIL = 'START_FETCH_POSTER_DETAIL'
export const SUCCESS_FETCH_POSTER_DETAIL = 'SUCCESS_FETCH_POSTER_DETAIL'
export const FAILED_FETCH_POSTER_DETAIL = 'FAILED_FETCH_POSTER_DETAIL'

export const UPDATE_TITLE = "UPDATE_TITLE";

export const CREATE_TICKET = "CREATE_TICKET";
export const UPDATE_TICKET = "UPDATE_TICKET";
export const DELETE_TICKET = "DELETE_TICKET";

export const ADD_TICKET_TO_TICKET_LIST = 'ADD_TICKET_TO_TICKET_LIST';
export const REMOVE_TICKET_FROM_TICKET_LIST = 'REMOVE_TICKET_FROM_TICKET_LIST';
export const UPDATE_TICKET_CONTENT = 'UPDATE_TICKET_CONTENT';

export const START_CREATE_TICKET = 'START_CREATE_TICKET'
export const SUCCESS_CREATE_TICKET = 'SUCCESS_CREATE_TICKET'
export const FAILED_CREATE_TICKET = 'FAILED_CREATE_TICKET'

export const START_DELETE_TICKET = 'START_DELETE_TICKET'
export const SUCCESS_DELETE_TICKET = 'SUCCESS_DELETE_TICKET'
export const FAILED_DELETE_TICKET = 'FAILED_DELETE_TICKET'

export const START_UPDATE_TICKET = 'START_UPDATE_TICKET'
export const SUCCESS_UPDATE_TICKET = 'SUCCESS_UPDATE_TICKET'
export const FAILED_UPDATE_TICKET = 'FAILED_UPDATE_TICKET'

export const REMOVE_CONTENT_ITEM = 'REMOVE_CONTENT_ITEM';
export const ADD_CONTENT_ITEM = 'ADD_CONTENT_ITEM';
export const UPDATE_CONTENT_ITEM = 'UPDATE_CONTENT_ITEM';

export const UPDATE_CONTENT_ITEM_ORDER = 'UPDATE_CONTENT_ITEM_ORDER';

export const UPDATE_CONTENT_ITEM_ID = 'UPDATE_CONTENT_ITEM_ID'; // when create a new content item, a new object(A) is inserted into an array before calling an API. When API is called and returns an ID for newly created item, we update that ID in object(A)
import getPosterDetail from 'controllers/poster/getPosterDetail'
import createTicketCtrl from 'controllers/ticket/createTicket'
import deleteTicketCtrl from 'controllers/ticket/deleteTicket'
import updateTicketCtrl from 'controllers/ticket/updateTicket'

import updateContentCtrl from 'controllers/poster/updateContent'
import deleteContentCtrl from 'controllers/poster/deleteContent'
import createContentCtrl from 'controllers/poster/createContent'

import moment from 'moment'

export function fetchPosterDetail(posterId, callback){

  return function(dispatch) {

    dispatch({
      type: START_FETCH_POSTER_DETAIL,
      fetching: true
    })

    getPosterDetail(posterId)
    .then((result) => {
      dispatch({
        type: SUCCESS_FETCH_POSTER_DETAIL,
        payload: {...result}
      })

      if(typeof(callback) == 'function'){
        callback()
      }
    })
    .catch((err)  => {
      dispatch({
        type: FAILED_FETCH_POSTER_DETAIL,
        payload: err
      })
    })
  }
}

export function updateTitle(title) {
  return function(dispatch) {
    dispatch({
      type: UPDATE_TITLE,
      title,
    });
  }
}

export function updateOrder(contentList, itemToMove) {
  return function(dispatch) {
    let toServer = {
      ...itemToMove,
    }

    contentList.forEach((item, index)=>{
      const newIndex = index + 1;
      item.index = newIndex;
      if (toServer.id === item.id) {
        toServer.index = newIndex;
      }
    });

    dispatch({
      type: UPDATE_CONTENT_ITEM_ORDER,
      contentList,
    });

    delete toServer.id;
    delete toServer.poster;

    updateContentCtrl(itemToMove.id, toServer)
      .then((res) => {
      })

  }
}

export function updateContentItem(index = 0, contentId, contentItemChanges) {
  return function(dispatch) {
    dispatch({
      type: UPDATE_CONTENT_ITEM,
      index,
      contentItemChanges,
    });

    delete contentItemChanges.id; // ID is not allowed

    updateContentCtrl(contentId, contentItemChanges)
      .then((res) => {
      })

  }
}

export function removeContentItem(index, contentId, posterId) {
  return function(dispatch) {
    dispatch({
      type: REMOVE_CONTENT_ITEM,
      index,
    });

    // this.countEmptyItem()
    if (contentId) {
      deleteContentCtrl(contentId)
      .then(() => {})
    }
  }
}

export function addContentItem(index, posterId, newContentItem, dontCallAPI) {
  return function(dispatch) {
    dispatch({
      type: ADD_CONTENT_ITEM,
      index: index + 1,
      newContentItem,
    });

    const contentIndex = index + 1;

    newContentItem.index = contentIndex + 1;

    if (dontCallAPI !== true) {
      createContentCtrl(posterId, newContentItem)
      .then((res)=>{
        dispatch({
          type: UPDATE_CONTENT_ITEM_ID,
          index: index + 1,
          id: res.content_block_id,
        });
      });
    }
  }
}

export function createTicket(posterId, ticket){

  return function(dispatch) {
    dispatch({
      type: START_CREATE_TICKET,
    })

    dispatch({
      type: CREATE_TICKET,
      ticket,
    })

    createTicketCtrl(posterId, ticket)
    .then((result) => {
      dispatch({
        type: SUCCESS_CREATE_TICKET,
        payload: {...result}
      })

      dispatch({
        type: UPDATE_TICKET,
        ticket: {
          ...ticket,
          id: result.ticket_id,
        }
      })

    })
    .catch((err)  => {
      dispatch({
        type: FAILED_CREATE_TICKET,
        payload: err
      })
    })
  }
}

export function deleteTicket(ticketId, ticketIndexInArray){

  return function(dispatch) {

    dispatch({
      type: START_DELETE_TICKET,
      ticketIndexInArray,
    })

    dispatch({
      type: DELETE_TICKET,
      ticketIndexInArray,
    })

    deleteTicketCtrl(ticketId)
    .then((result) => {
      dispatch({
        type: SUCCESS_DELETE_TICKET,
        payload: {...result}
      })
    })
    .catch((err)  => {
      dispatch({
        type: FAILED_DELETE_TICKET,
        payload: err
      })
    })
  }
}


export function updateTicket(ticketId, ticket){

  return function(dispatch) {

    dispatch({
      type: START_UPDATE_TICKET,
    })

    dispatch({
      type: UPDATE_TICKET,
      ticket,
    })

    updateTicketCtrl(ticketId, convertTicketToServer(ticket))
    .then((result) => {
      dispatch({
        type: SUCCESS_UPDATE_TICKET,
        payload: { ...result }
      })
    })
    .catch((err)  => {
      dispatch({
        type: FAILED_UPDATE_TICKET,
        payload: err,
      })
    })
  }
}

const initState = {
  contentList: [],
  detail: {},

}

const POSTER_TYPE = ["registration", "ticket", 'survey', 'basic']


export default function posterDetail(state = initState, action){
  switch(action.type){
    // ===================================
    //  actions for fetching poster detail
    // ===================================
    case START_FETCH_POSTER_DETAIL: {
      return {
        ...state,
        fetching: true,
        contentList: [],
        ticketList: [],
        detail: {},
        poster_type: undefined,
        title: undefined,
      }
    }
    case SUCCESS_FETCH_POSTER_DETAIL: {
      const {
        poster_info, content, ticket,
      } = action.payload;

      return {
        ...state,
        title: poster_info.title,
        hasTitle: typeof poster_info.title === 'string' && poster_info.title.length > 0,
        detail: poster_info,
        contentList: content,
        ticketList: ticket.map((ticketFromServer)=>{
          return convertTicketFromServer(ticketFromServer);
        }),
        poster_type: POSTER_TYPE[poster_info.poster_type],
        fetching: false
      }
    }
    case FAILED_FETCH_POSTER_DETAIL: {
      return state
    }

    // ===================================
    //  updating content editor part
    //  of posterdetail
    // ===================================
    case UPDATE_TITLE: {
      const { title } = action;

      return {
        ...state,
        title,
        hasTitle: typeof title === 'string' && title.length > 0,
      }
      break;
    }

    case UPDATE_CONTENT_ITEM_ORDER: {
      const { contentList } = action;
      return {
        ...state,
        contentList,
      }
      break;
    }


    case UPDATE_CONTENT_ITEM: {
      const { index, contentItemChanges } = action;

      return {
        ...state,
        contentList: state.contentList.map((item, i)=>{
          return i === index ? { ...item, ...contentItemChanges, } : item;
        }),
      }

      break;
    }

    case UPDATE_CONTENT_ITEM_ID: {
      const { index, id } = action;

      return {
        ...state,
        contentList: state.contentList.map((item, i)=>{
          return i === index ? { ...item, id, } : item;
        }),
      }
    }

    case ADD_CONTENT_ITEM: {
      const { index, newContentItem } = action;

      return {
        ...state,
        contentList: [
          ...state.contentList.slice(0, index),
          newContentItem,
          ...state.contentList.slice(index),
        ]
      };

      break;
    }

    case REMOVE_CONTENT_ITEM: {
      const { index } = action;

      return {
        ...state,
        contentList: [
          ...state.contentList.slice(0, index),
          ...state.contentList.slice(index + 1)
        ]
      }

      break;
    }

    // ===================================
    //  actions for local states for ticket
    // ===================================
    case CREATE_TICKET: {
      return {
        ...state,
        ticketList: [ ...state.ticketList, action.ticket,],
      }
    }

    case UPDATE_TICKET: {
      const {
        index,
      } = action.ticket;

      return {
        ...state,
        ticketList: state.ticketList.map((existingTicket, i)=>{
          return index === i + 1 ? { ...existingTicket, ...action.ticket } : existingTicket;
        })
      }
    }

    case DELETE_TICKET: {
      const {
        ticketIndexInArray,
      } = action;

      return {
        ...state,
        ticketList: [
          ...state.ticketList.slice(0, ticketIndexInArray),
          ...state.ticketList.slice(ticketIndexInArray + 1)
        ]
      }
    }
    // ===================================
    //  actions for API calls creating ticket
    // ===================================
    case START_CREATE_TICKET: {
      return {
        ...state,
        loading: true
      }
    }
    case SUCCESS_CREATE_TICKET: {
      const {ticket_id, index} = action.payload
      return {
        ...state,
        loading: false,
      }
    }
    case FAILED_CREATE_TICKET: {
      return {
        ...state,
        loading: false
      }
    }

    // ===================================
    //  actions for API calls deleting ticket
    // ===================================
    case START_DELETE_TICKET: {
      return {
        ...state,
        loading: true,
        ticketList: [
          ...state.ticketList.slice(0, action.ticketIndexInArray),
          ...state.ticketList.slice(action.ticketIndexInArray + 1)
        ],
      }
    }
    case SUCCESS_DELETE_TICKET: {
      return {
        ...state,
        loading: false
      }
    }
    case FAILED_DELETE_TICKET: {
      return {
        ...state,
        loading: false
      }
    }

    // ===================================
    //  actions for API calls updating ticket
    // ===================================
    case START_UPDATE_TICKET: {
      return {
        ...state,
        loading: true,
      }
    }
    case SUCCESS_UPDATE_TICKET: {
      return {
        ...state,
        loading: false,
      }
    }
    case FAILED_UPDATE_TICKET: {
      return {
        ...state,
        loading: false
      }
    }

    default: return {...state}
  }
}

function convertTicketFromServer(opts){
  const {id, index, title, amount, price, auto_wait_list, start_at, end_at, price_type} = opts;

  let endDate, endTime;

  if (end_at) {
    const endMoment = moment(end_at);
    endDate = endMoment.format('YYYY-MM-DD');
    endTime = endMoment.format('HH:mm:ss');
  }

  let startDate, startTime;

  if (start_at) {
    const startMoment = moment(start_at);
    startDate = startMoment.format('YYYY-MM-DD');
    startTime = startMoment.format('HH:mm:ss');
  }

  const PRICE_TYPE = ['freeOrPayOffline', 'fixedAmount', 'noFixAmount']


  return{
    id,
    index,
    title,
    amount,
    price,
    auto_wait_list,
    noEndTime: !end_at ? true : false,
    startDate,
    startTime,
    endDate,
    endTime,
    price_type: PRICE_TYPE[price_type],
  }
}

function convertTicketToServer({index, title, amount, price, startDate, startTime, endDate, endTime, auto_wait_list, noEndTime}){
  const noStartTime = !startDate || !startTime;

  let obj = {
    index,
    title,
    amount: Number(amount),
    price,
    auto_wait_list,
    start_at: noStartTime ? null : startDate + ' ' + startTime,
    end_at: noEndTime ? null : endDate + ' ' + endTime
  }

  if (obj.noEndTime == false){
    obj.end_at = endDate + ' ' + endTime
  }

  return obj
}



// WEBPACK FOOTER //
// ./src/containers/pages/Poster/EditPoster/ducks.js